<template>
  <div v-show="true" class="d-lg-flex align-items-lg-center">
    <BButton class="w-100" variant="primary" @click="$emit('action')"><i class="fas fa-plus"></i> {{ text }}</BButton>
  </div>
</template>

<script>
// import { ref } from "vue";
import { BButton } from "bootstrap-vue-next";
// Define the 'text' prop
export default{
  props: {
    text: String,
    show: Boolean,
  },
  components: {
    BButton
  },
  setup(props){
    // const show = ref(false)
    console.log(props)

    
    return {
      // show,
    }
  }
}
</script>

<style>
/* Add your styles here */
</style>
